export const getUserName = `query getUser{
  getUser{
      uid
      name
      email
      registration_number
      tax_number
  }
}`;
